/* eslint-disable no-undef */
/* eslint-disable no-useless-escape */
'use strict';

var base = require('base/product/base');
var carousel = require('../components/carousel');
const { MiniCartFlyOutRecommendationCarouselConfig } = require('../components/carouselConfig.js');
var utils = require('plugin_jac/util');

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
	var options = $productContainer
		.find('.product-option')
		.map(function () {
			var $elOption = $(this).find('.options-select');
			var urlValue = $elOption.val();
			var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
				.data('value-id');
			return {
				optionId: $(this).data('option-id'),
				selectedValueId: selectedValueId
			};
		}).toArray();

	return JSON.stringify(options);
}

//Retrieve the Productset Details in case of add all items to cart
function getAllProductSetItemforCart(){
	var allProductSetItem = [];
	
	var pageListEle = $('#navigatedPDPInfo');
	var pageListName = (pageListEle && pageListEle.attr('data-nav-pdpinfo')) ? $.trim(pageListEle.attr('data-nav-pdpinfo')) : '';
	var stlID = ($('.product-set-detail').length > 0) ? $('.product-set-detail').data('pid') : '';
	$('.add-to-cart:visible').each(function(){
		var ratings;
		var product = $(this).attr('data-pdpaddtocart-name');
		var masterID = $(this).attr('data-pid-m');
		var selectedPrice = $(this).attr('gtm-price-data');
		var variantID = $(this).attr('gtm-variant-id');
		var category = $(this).attr('gtm-category-data');
		var quantityElement = $(this).parents('.productSetItemAction ').find('.quantity-select option:selected');
		var selectedQuantity = quantityElement.length ? parseInt(quantityElement[0].value) : 1;
		var ratingLabel = $(this).parents('.product-detail.set-item').find('.yotpo-stars .sr-only').text();
	
		var gtmKitData = {
			name : product && product.replace(/"/g, ''),
			id : masterID,
			brand : 'James Avery',
			price : Number(parseFloat(selectedPrice && selectedPrice.replace('$', '')).toFixed(2)),
			category : category,
			variant : variantID,
			quantity : Number(selectedQuantity),
			list: pageListName,
			shopTheLookID:stlID
		};
		
		
		//Dimension Params
		var dimensionParams = $(this).attr('data-selected-variant');
		if(dimensionParams){
			var selectedVariants = JSON.parse(dimensionParams);
			selectedVariants.forEach(function (variant) {
				if(variant.displayName == 'Metal'){
					gtmKitData.dimension1 = variant.displayValue;
				}
				if(variant.displayName == 'Gemstone'){
					gtmKitData.dimension2 = variant.displayValue;
				}
				if(variant.displayName == 'Size'){
					gtmKitData.dimension3 = variant.displayValue;
				}
				if(variant.displayName == 'Color'){
					gtmKitData.dimension4 = variant.displayValue;
				}
			});
		}else{
			var gtmPDPInfo = $(this).attr('data-gtm-pdp');
			if(gtmPDPInfo){
				gtmPDPInfo = JSON.parse(gtmPDPInfo);
				if(gtmPDPInfo.dimension1){
					gtmKitData.dimension1 = gtmPdpData.dimension1;
				}

				if(gtmPDPInfo.dimension2){
					gtmKitData.dimension2 = gtmPdpData.dimension2;
				}

				if(gtmPDPInfo.dimension3){
					gtmKitData.dimension3 = gtmPdpData.dimension3;
				}

				if(gtmPDPInfo.dimension4){
					gtmKitData.dimension4 = gtmPdpData.dimension4;
				}	
			}
		}

		if(ratingLabel){
			ratings = ratingLabel.split(' ');
			if (ratings[0] > 0) {
				gtmKitData['productRating'] = parseFloat(ratings[0]);
			}
		}

		allProductSetItem.push(gtmKitData);

	});
	
	return allProductSetItem;

}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
	return $('.add-to-cart-url').val();
}

/**
 * Prepare a sanitized input for the listName parameter
 * Pass the field to be sanitized
 *
 * @return {array} - sanitized string
 */
function sanitizeFieldInput(inputString) {
	if(inputString){
		var outputString = '';

		outputString = inputString.replace(/<script[^>]*?>.*?<\/script>/gi, '').replace(/<[\/\!]*?[^<>]*?>/gi, '').
			replace(/<style[^>]*?>.*?<\/style>/gi, '').
			replace(/<![\s\S]*?--[ \t\n\r]*>/gi, '').
			replace(/&nbsp;/g, '');

		return outputString;

	}
}

/**
 * Prepare an array of objects of products being added to cart
 * pid as key and listName as value
 *
 * @return {array} - array of reduced object data for analytics
 */
function getAnalyticsProductListData(item, isCYO) {
	var listArray = [];
	if (item) {
		//ID is Variant id for CYO Products and For normal product refer Variant for Variant ID
		listArray = (isCYO) ? item.map(({ variant, list, productRating }) => ({ 'pid': variant, 'listName': sanitizeFieldInput(list), 'productRating': productRating })) : item.map(({ variant, list, productRating }) => ({ 'pid': variant, 'listName': sanitizeFieldInput(list), 'productRating': productRating }));
	}
	return encodeURIComponent(JSON.stringify(listArray));
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
	var childProducts = [];
	$('.bundle-item').each(function () {
		childProducts.push({
			pid: $(this).find('.product-id').text(),
			quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
		});
	});

	return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieves all the Attached charms PIDs 
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getCyoChildProducts(childProducts) {
	let childProductPids = [];
	$.each(childProducts, function (key) {
		childProductPids.push({
			pid: childProducts[key].pid,
			hotspotLinkPos: childProducts[key].hotspotLinkPos,
			hotspotPosition: childProducts[key].hotspotPosition,
			list: childProducts[key].listCategory,
			quantity: 1,
			uuid: childProducts[key].uuid ? childProducts[key].uuid : null,
			hasEngraved: childProducts[key].isEngraved ? childProducts[key].isEngraved : false
		});
	});

	return childProductPids.length ? JSON.stringify(childProductPids) : [];
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response,cartBtn) {
	var setItemEle = cartBtn.parents('.product-detail.set-item');
	var $pdpContainer = (setItemEle && setItemEle.length > 0) ? setItemEle : cartBtn.closest('.product-detail');
	var variationSelectionEle = $pdpContainer.find('.variation-selection-error-message');
	var selectionErrorEle = $pdpContainer.find('.selection-error-message');
	$('.minicart').trigger('count:update', response);
	// show add to cart toast
	// var messageType = response.error ? 'alert-danger' : 'alert-success';
	if (response.newBonusDiscountLineItem
		&& Object.keys(response.newBonusDiscountLineItem).length !== 0) {
		// chooseBonusProducts(response.newBonusDiscountLineItem);
	} if (response.error) {
		if (variationSelectionEle.length && variationSelectionEle.hasClass('d-none')) {
			variationSelectionEle.removeClass('d-none');
			selectionErrorEle.text(response.message);
		}
	} else {
		if ($('.add-to-cart-messages').length === 0) {
			$('body').append(
				'<div class="add-to-cart-messages"></div>'
			);
		}
		// $('.add-to-cart-messages').append(
		// 	'<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
		// 	+ response.message
		// 	+ '</div>'
		// );

		if (variationSelectionEle.length && !variationSelectionEle.hasClass('d-none')) {
			selectionErrorEle.text('');
			variationSelectionEle.addClass('d-none');
		}

		setTimeout(function () {
			$('.add-to-basket-alert').remove();
		}, 5000);
	}
}
/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
	var quantitySelected;
	if ($el && $('.set-items').length) {
		quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
	} else if ($el && $('.product-bundle').length) {
		var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
		var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
		if (quantitySelectedModal.val() === undefined) {
			quantitySelected = quantitySelectedPDP;
		} else {
			quantitySelected = quantitySelectedModal;
		}
	} else {
		quantitySelected = $('.quantity-select');
	}
	return quantitySelected;
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
	attr.values.forEach(function (attrValue) {
		var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
			attrValue.value + '"]');
		var $swatchButton = $attrValue.parent();

		if (attrValue.selected) {
			$attrValue.addClass('selected');
			$attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
		} else {
			$attrValue.removeClass('selected');
			$attrValue.siblings('.selected-assistive-text').empty();
		}
		if(Object.prototype.hasOwnProperty.call(attrValue, 'showValue')){
			if(attrValue.showValue){
				$attrValue.removeClass('d-none');
			}else{
				$attrValue.addClass('d-none');
			}
		}

		if (attrValue.url) {
			$swatchButton.attr('data-url', attrValue.url);
		} else {
			$swatchButton.removeAttr('data-url');
		}

		// Disable if not selectable
		$attrValue.removeClass('selectable unselectable');

		$attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
		$swatchButton.addClass(attrValue.selectable ? 'selectable' : 'unselectable');

		if ($attrValue.hasClass('selectable')) {
			$swatchButton.removeClass('unselectable');
		}
	});
	//changes for the dropdown
	processNonSwatchValues(attr, $productContainer);
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
	var $attr = '[data-attr="' + attr.id + '"]';
	var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
	$defaultOption.attr('value', attr.resetUrl);

	attr.values.forEach(function (attrValue) {
		var $attrValue = $productContainer
			.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
		$attrValue.attr('value', attrValue.url)
			.removeAttr('disabled');
	});
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
	// Currently, the only attribute type that has image swatches is Color.
	//Changed to metal for the available swatches- need to have the dynamic configuration
	var attrsWithSwatches = ['metal', 'size', 'letterName', 'gcDenomination', 'numberName', 'webGemstone', 'color', 'artGlass'];

	attrs.forEach(function (attr) {
		if (attrsWithSwatches.indexOf(attr.id) > -1) {
			processSwatchValues(attr, $productContainer, msgs);
		} else {
			processNonSwatchValues(attr, $productContainer);
		}
	});
}

function varaitionNotSelectedError($pdpContainer) {
	let nonSelectedVariations = $pdpContainer.find('.variationOption').not(':has(.variation-value.selected)');
	for (let i = 0; i < nonSelectedVariations.length; i++) {
		let errorMsg = $(nonSelectedVariations[i]).data('attr-missing-error');
		$(nonSelectedVariations[i]).addClass('variation-missing-error');
		$(nonSelectedVariations[i]).find('.variation-not-selected-error').text(errorMsg);
		$(document).trigger('gtm:pdpVariationErrors', errorMsg);
	}
	if($pdpContainer.find('.variation-missing-error').length > 0) {
		$(document).scrollTop($pdpContainer.find('.variation-missing-error').offset().top);
	}
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
	var shippingAvailabilityValue = '';
	var shippingMessage = response.product && response.product.inventoryMessage.displayMessage || '';
	var shippingClass = response.product && response.product.inventoryMessage.availabilityStatusClass;
	var pickupAvailabilityValue = '';
	var pickupMessage = response.product && response.product.realTimeStoreInventory ? response.product.realTimeStoreInventory.displayMessage || '' : response.inventorystatus ? response.inventorystatus.displayMessage || '' : '';
	var pickupClass = response.product && response.product.realTimeStoreInventory ? response.product.realTimeStoreInventory.availabilityStatusClass || '' : response.inventorystatus ? response.inventorystatus.availabilityStatusClass : '';

	shippingAvailabilityValue += '<li class='+ shippingClass + '>' + shippingMessage + '</li>';
	pickupAvailabilityValue += '<li class='+ pickupClass + '>' + pickupMessage + '</li>';

	if($($productContainer).closest('.bundle-item').length > 0) {
		$productContainer = $productContainer.parents('.product-detail');
	}

	$($productContainer).trigger('product:updateAvailability', {
		product: response.product,
		$productContainer: $productContainer,
		shippingMessage: shippingAvailabilityValue,
		pickupMessage: pickupAvailabilityValue,
		resources: response.resources
	});

	if(response.product){
		$productContainer.find('.shipping-msg').attr('data-qty', response.product.inventoryMessage.ats);
		if (response.product.realTimeStoreInventory) $productContainer.find('.pickup-msg').attr('data-qty', response.product.realTimeStoreInventory.availableCount);
	}
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
	if (!attributes) {
		return '';
	}

	var html = '';

	attributes.forEach(function (attributeGroup) {
		if (attributeGroup.ID === 'mainAttributes') {
			attributeGroup.attributes.forEach(function (attribute) {
				html += '<div class="attribute-values">' + attribute.label + ': '
					+ attribute.value + '</div>';
			});
		}
	});

	return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
	// Update options
	$productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, $productContainer) {
	var carousel = $productContainer.find('.s7-carousel');
	$(carousel).empty();
	if (imgs.length > 0) {
		var zoomViewer;
		var deviceWidth = $(window).width();
		var viewerConfig =
			(deviceWidth <= 1280 || $productContainer.hasClass('product-quickview'))
				? window.SitePreferences.SCENE7_CYO_CONFIG
				: window.SitePreferences.SCENE7_PDP_CONFIG;
		var enableZoomHandler = (deviceWidth <= 1280 || $productContainer.hasClass('product-quickview')) ? true : false;
		var swatchesAlign =  enableZoomHandler ? 'left,bottom' : 'left,top';
		var swatchTblLayout = enableZoomHandler ? '0,1' : '1,0';
		zoomViewer = new s7viewers.MixedMediaViewer({
			'containerId': carousel.attr('id'),
			'params': {
				'asset': imgs[0].assetId,
				'serverurl': 'https://jamesavery.scene7.com/is/image/',
				'videoserverurl': 'https://jamesavery.scene7.com/is/content/',
				'config': 'JamesAvery/' + viewerConfig,
				'contenturl': 'https://jamesavery.scene7.com/is/content/',
				'FlyoutZoomView.tip': '0,0,0.0',
				'Swatches.align': swatchesAlign,
				'Swatches.tmblayout': swatchTblLayout,
				'Swatches.enableScrollButtons': enableZoomHandler ? '0' : '1',
				'swatchoverlay': '0',
				'ZoomView.iconeffect': '0'
			},
			'handlers': {
				'initComplete': function initComplete() {
					var id = carousel.attr('id');
					var element = $('#'+carousel.attr('id')+'_swatches');
					var swatchCount = $(element).find('.s7thumbcell').length;
					if(swatchCount == 1){
						$(element).parents('.s7-carousel').addClass('swatch-wrapper');
						$(element).css('visibility','inherit');
					}
					(enableZoomHandler) ? $(element).children().addClass('swatch-container') : '';
					(deviceWidth <= 1280 && swatchCount > 1) ? utils.selectSwatchOnViewerSwipe(zoomViewer,carousel) : '';
					utils.onLoadSEOUpdateOnViewerImages(id);	
					utils.dynamicSEOUpdateOnViewerImages(id);
				}
			}
		});
		zoomViewer.init();

	}
}

function updatewishlist(iswishlistfilled, $productContainer) {
	var button = $productContainer.find('.add-to-wish-list');
	if (iswishlistfilled) {
		button.find($('i')).removeClass('fa-heart-o').addClass('fa-heart');
	}
	else {
		button.find($('i')).removeClass('fa-heart').addClass('fa-heart-o');
	}
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
	var isChoiceOfBonusProducts =
		$productContainer.parents('.choose-bonus-product-dialog').length > 0;
	var isVaraint;
	if (response.product.variationAttributes) {
		updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
		isVaraint = response.product.productType === 'variant';
		if (isChoiceOfBonusProducts && isVaraint) {
			$productContainer.parent('.bonus-product-item')
				.data('pid', response.product.id);

			$productContainer.parent('.bonus-product-item')
				.data('ready-to-order', response.product.readyToOrder);
		}
	}

	// Update primary images
	var primaryImageUrls = response.product.images.large;
	createCarousel(primaryImageUrls, $productContainer);
	updatewishlist(response.product.wishlistProductExist, $productContainer);
	// Update pricing
	if (!isChoiceOfBonusProducts && !$productContainer.hasClass('bundle-item')) {
		var $priceSelector = $('.prices .price', $productContainer).length
			? $('.prices .price', $productContainer)
			: $('.prices .price');
		$priceSelector.replaceWith(response.product.price.html);

		// updating gtm attributes here
		let atcButton = $('button.add-to-cart', $productContainer);
		if (atcButton.length) {
			atcButton.attr('gtm-variant-id', response.product.id);
			atcButton.attr('data-selected-variant', JSON.stringify(response.product.variationAttributes));
			atcButton.attr('gtm-price-data', response.product.price.sales && response.product.price.sales.value);
		}
		// Updating the Product ID with full SKU ID instead of masterID 
		let productSkuId = $productContainer.find('.product-details-id');
		productSkuId.html(response.product.id);
		
		if(response.product.retiredDate){
			let offlineProductRetiredDate = $productContainer.find('.product-details-retiredDate');
			offlineProductRetiredDate.html(response.product.retiredDate);
		}
	}

	// Update promotions
	$productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

	// update store selection message
	if (response.product.inventoryMessage && response.product.inventoryMessage.availabilityStatusClass === 'outOfStock' && !response.product.myStore.store) {
		var storeSelectionErrorMessage = $('.shipping-pickup-store', response.$productContainer).attr('data-storeerror-message');
		$('.shipping-pickup-store', response.$productContainer).attr('data-nostore-selection', storeSelectionErrorMessage);
	} else {
		$('.shipping-pickup-store', response.$productContainer).removeAttr('data-nostore-selection');
	}

	//update the add to favourites button
	if ($('.add-to-favourites').length) {
		$('.add-to-favourites').attr('data-readyto-order',response.product.readyToOrder);
	}
	// update GiftCard inventory messages
	if (response.product.isGiftCard) {
		$('.pickup-msg', response.$productContainer).addClass('d-none');
	} else {
		$('.pickup-msg', response.$productContainer).removeClass('d-none');
	}

	// update Klarna Info on PDP
	$productContainer.find('.klarna-info').empty().html(response.product.klarnaHtml);
	window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
	window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });


	updateAvailability(response, $productContainer);

	if (isChoiceOfBonusProducts) {
		var $selectButton = $productContainer.find('.select-bonus-product');
		$selectButton.trigger('bonusproduct:updateSelectButton', {
			product: response.product, $productContainer: $productContainer
		});
	} else {
		// Enable "Add to Cart" button if all required attributes have been selected
		$('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global, button.btn-secondary-cyo').trigger('product:updateAddToCart', {
			product: response, $productContainer: $productContainer
		}).trigger('product:statusUpdate', response.product);
	}

	// Update attributes
	$productContainer.find('.main-attributes').empty()
		.html(getAttributesHtml(response.product.attributes));

	// Clear variation not selection error message
	$productContainer.find('.variationOption:has(.variation-value.selected)').removeClass('variation-missing-error');
	
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
	if ($productContainer.parent('.bonus-product-item').length <= 0) {
		var maxOrderQuantity = quantities.length;
		var optionsHtml = quantities.map(function (quantity) {
			var selected = quantity.selected ? ' selected ' : '';
			return '<option min="1" max="' + maxOrderQuantity + '" value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
				selected + '>' + quantity.value + '</option>';
		}).join('');
		getQuantitySelector($productContainer).empty().html(optionsHtml);
	}
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
	if (selectedValueUrl) {
		$('body').trigger('product:beforeAttributeSelect',
			{ url: selectedValueUrl, container: $productContainer });

		const searchParams = new URLSearchParams(window.location.search);
		if (searchParams.get('isRetired') == 'true') {
			var urlQueryParams = selectedValueUrl.split('?')[1].split('&');
			var selectedAttr = urlQueryParams[0].split('=')[0].split('_')[2];
			var multiplevariationOptions = $('.variationOption').find('.variation-attribute').find('.selected');
			
			multiplevariationOptions.each(function(index) {
				var attributeValue = multiplevariationOptions[index].dataset.id ? multiplevariationOptions[index].dataset.id : multiplevariationOptions[index].dataset.variant;
				if (attributeValue && attributeValue != selectedAttr) {
					var qParams = '&dwvar_'+$productContainer[0].dataset.pid+'_'+attributeValue+'='+multiplevariationOptions[index].dataset.attrValue;
					selectedValueUrl = selectedValueUrl+qParams;
				}  
			});
		}
		$.ajax({
			url: selectedValueUrl,
			method: 'GET',
			success: function (data) {
				handleVariantResponse(data, $productContainer);
				updateOptions(data.product.optionsHtml, $productContainer);
				updateQuantities(data.product.quantities, $productContainer);
				if (data.isPosMode) {
					updateInventoryTable(data.product);
				}
				$('body').trigger('product:afterAttributeSelect',
					{ data: data, container: $productContainer });
				$.spinner().stop();
			},
			error: function () {
				$.spinner().stop();
			}
		});
	}
}

function handlePromoAnalytics(product){
	if(product.isProratedPromoApplied || product.proratedMissedMessage){
		if(product.isProratedPromoApplied){
			$('body').trigger('charmPromo:progress','100%');
		}else if(product.proratedMissedMessage) {
			if(product.proratedMissedMessage.charmQuantity == 1 && product.proratedMissedMessage.holderQuantity == 0){
				$('body').trigger('charmPromo:progress','33%');
			} else if(product.proratedMissedMessage.charmQuantity == 0 && product.proratedMissedMessage.holderQuantity >= 1){
				$('body').trigger('charmPromo:progress','33%');
			} else if(product.proratedMissedMessage.charmQuantity == 1 && product.proratedMissedMessage.holderQuantity >= 1){
				$('body').trigger('charmPromo:progress','66%');
			} else if(product.proratedMissedMessage.charmQuantity > 1) {
				$('body').trigger('charmPromo:progress','66%');
			}
		}
	}
}

function colorAttribute() {

	$(document).on('click', '.variationOption button', function (e) {
		e.preventDefault();
		if ($(e.currentTarget).attr('disabled')) {
			return;
		}
		var $productContainer = $(e.currentTarget).closest('.set-item');
		if (!$productContainer.length) {
			$productContainer = $(e.currentTarget).closest('.product-detail');
		}
		let swatchCircleSelected = $(e.currentTarget).children('.swatch-circle.selected');
		let SquareBoxSelected = $(e.currentTarget).children('.select-box.selected');
		if (swatchCircleSelected.length > 0 || SquareBoxSelected.length > 0) {
			return;
		}

		attributeSelect($(e.currentTarget).attr('data-url'), $productContainer);
	});
}

function updateInventoryTable(product) {
	var tableUpdateUrl = $('.posInventoryData').attr('data-url') ? $('.posInventoryData').attr('data-url') : '';

	if (tableUpdateUrl.indexOf('?') < 0) {
		tableUpdateUrl = tableUpdateUrl + '?productID=' + product.id + '&productType=' + product.productType;
	} else {
		tableUpdateUrl = tableUpdateUrl + '&productID=' + product.id + '&productType=' + product.productType;
	}
	$('.inventory-table-overlay').removeClass('d-none');
	$.ajax({
		url: tableUpdateUrl,
		method: 'GET',
		success: function (data) {
			$('.pos-inventory-table').replaceWith(data);
			$('.inventoryErrorMsg').addClass('d-none');
			$('.posInventoryData inventoryMasterMsg').addClass('d-none');
			$('.posInventoryData inventoryTable').removeClass('d-none');
			$('.inventory-table-overlay').addClass('d-none');
		},
		error: function () {
			$('.posInventoryData').addClass('d-none');
			$('.inventoryErrorMsg').removeClass('d-none');
			$('.inventory-table-overlay').addClass('d-none');
		}
	});

}

var exportBase = $.extend({}, base, {
	attributeSelect: attributeSelect,
	colorAttribute: colorAttribute,
	availability: function () {
		$(document).on('change', '.quantity-select', function (e) {
			e.preventDefault();

			var $productContainer = $(this).closest('.product-detail');
			if (!$productContainer.length) {
				$productContainer = $(this).closest('.modal-content').find('.product-quickview');
			}

			if ($('.bundle-items', $productContainer).length === 0) {
				attributeSelect($(e.currentTarget).find('option:selected').data('url'),
					$productContainer);
			}
		});
	},

	selectAttribute: function () {
		$(document).on('change', 'select[class*="select-"], .options-select', function (e) {
			e.preventDefault();
			var $productContainer = $(this).closest('.set-item');
			if (!$productContainer.length) {
				$productContainer = $(this).closest('.product-detail');
			}
			attributeSelect(e.currentTarget.value, $productContainer);
		});
	},

	addToCart: function () {
		$(document).on('click', '.modal-backdrop', function () {
			if ($('#itemAddedFlyout').length) {
				$('#itemAddedFlyout').remove();
				$('.modal-backdrop').remove();
				$('body').removeClass('modal-open');
				$('body').removeAttr('style');
			}
		});
		$(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
			var addToCartUrl;
			var pid;
			var pidsObj;
			var setPids;
			var ratings;
			var productSetitems = [];
			var isEngraving = false;
			var addAllitemtoCart = false;
			var isCyoExperience = false;
			var thisEle = $(this);
			var pageListEle = $('#navigatedPDPInfo');
			var product = $(this).attr('data-pdpaddtocart-name');
			var selectedPrice = $(this).attr('gtm-price-data');
			var fromCYO = $(this).hasClass('fromcyo');
			var category = $(this).attr('gtm-category-data');
			var masterID = $(this).attr('data-pid-m');
			var pageListName = (pageListEle && pageListEle.attr('data-nav-pdpinfo')) ? $.trim(pageListEle.attr('data-nav-pdpinfo')) : '';
			var variantID = $(this).attr('gtm-variant-id');
			var quantityElement = $('.quantity.attribute .quantity-select option:selected');
			var selectedQuantity = quantityElement.length ? parseInt(quantityElement[0].value) : 1;
			var gtmPdpData = $(this).attr('data-gtm-pdp-product') ? JSON.parse($(this).attr('data-gtm-pdp-product')):'';
			var gtmAddToCartData = $(this).data('gtm-array');
			var setItemEle = $(this).parents('.product-detail.set-item');
			var isProductSet = setItemEle && setItemEle.length > 0 ? true : false;
			var analyticsAddToCartData = [];// Analytics data for product list name
			var stlID = ($('.product-set-detail').length > 0) ? $('.product-set-detail').data('pid') : '';
			var gtmKitData = {
				name : product && product.replace(/"/g, ''),
				id : masterID,
				brand : 'James Avery',
				price : Number(parseFloat(selectedPrice && selectedPrice.replace('$', '')).toFixed(2)),
				category : category,
				variant : variantID,
				quantity : Number(selectedQuantity),
				list: pageListName
			};	

			if(stlID) { 
				gtmKitData.shopTheLookID = stlID;
			}
			// Find rating from DOM element
			var productRating = '';
			if(isProductSet){
				var ratingLabel = $(this).parents('.product-detail.set-item').find('.yotpo-stars .sr-only').text();
				if(ratingLabel){
					ratings = ratingLabel.split(' ');
					productRating = (ratings && ratings[0] > 0) ? parseFloat(ratings[0]) : ''; 
				}
			}else{
				var productRatingEle = $('.product-detail .yotpo-main-widget .avg-score') && $('.product-detail .yotpo-main-widget .avg-score').length > 0 ? parseFloat($.trim($('.product-detail .yotpo-main-widget .avg-score').text())) : '';
				productRating = (productRatingEle > 0) ? parseFloat(productRatingEle) : '';
			}
			if (productRating) {
				gtmKitData.productRating = productRating;
			}

			//Dimension Params
			var dimensionParams = $(this).attr('data-selected-variant');
			if(dimensionParams){
				var selectedVariants = JSON.parse(dimensionParams);
				selectedVariants.forEach(function (variant) {
					if(variant.displayName == 'Metal'){
						gtmKitData.dimension1 = variant.displayValue;
					}
					if(variant.displayName == 'Gemstone'){
						gtmKitData.dimension2 = variant.displayValue;
					}
					if(variant.displayName == 'Size'){
						gtmKitData.dimension3 = variant.displayValue;
					}
					if(variant.displayName == 'Color'){
						gtmKitData.dimension4 = variant.displayValue;
					}
				});
			} else {
				var gtmPDPInfo = $(this).attr('data-gtm-pdp');			
				if(gtmPDPInfo){
					gtmPDPInfo = JSON.parse(gtmPDPInfo);
					if(gtmPDPInfo.dimension1){
						gtmKitData.dimension1 = gtmPdpData.dimension1;
					}

					if(gtmPDPInfo.dimension2){
						gtmKitData.dimension2 = gtmPdpData.dimension2;
					}

					if(gtmPDPInfo.dimension3){
						gtmKitData.dimension3 = gtmPdpData.dimension3;
					}

					if(gtmPDPInfo.dimension4){
						gtmKitData.dimension4 = gtmPdpData.dimension4;
					}	
				}
			}

			if ($(this).attr('data-error-message')) {

				var $pdpContainer = isProductSet ? setItemEle : $(this).closest('.product-detail');
				$pdpContainer.find('.variationOption').removeClass('variation-missing-error');
				$('.variation-not-selected').empty();
				var shippingStock = $pdpContainer.find('.shipping-delivery-selection .availability-msg');
				var pickupStoreStock = $pdpContainer.find('.shipping-pickup-store .availability-msg');
				var pdpStockMsgShown = shippingStock.find('.inStock').length > 0 || shippingStock.find('.outOfStock').length > 0 || 
										pickupStoreStock.find('.inStock').length > 0 || pickupStoreStock.find('.outOfStock').length > 0 ? true : false;

				if ($pdpContainer.find('.variation-value.selected').length === $pdpContainer.find('.variationOption').length && !pdpStockMsgShown) {
					// If all variation options selected and no stock messages shown, whether OOS/IS this implies 
					// selected variation not available for product.Then show not available message, else continue to appropriate error msg
					$(this).closest('.product-detail').find('.variation-selection-error-message').removeClass('d-none');
					$(this).closest('.product-detail').find('.selection-error-message').text($(this).attr('data-not-available'));
				}else if ($(this).hasClass('global-cart-button') && $(this).parents('.cart-and-ipay').find('.variation-selection-error-message').hasClass('d-none')) {
					$(this).parents('.cart-and-ipay').find('.variation-selection-error-message').removeClass('d-none');
					$(this).parents('.cart-and-ipay').find('.selection-error-message').text($(this).attr('data-error-message'));
				} else if($(this).closest('.product-detail').find('.variation-selection-error-message'))  {
					if ($(this).attr('data-readyto-order') === false || $(this).attr('data-readyto-order') === 'false') {
						varaitionNotSelectedError($pdpContainer);
					} else {
						$(this).closest('.product-detail').find('.variation-selection-error-message').removeClass('d-none');
						$(this).closest('.product-detail').find('.selection-error-message').text($(this).attr('data-error-message'));
					}	
				}
				return;
			}

			// if ($(this).attr('data-urgency-message')) {
			// 	return;
			// }


			if($(this).data('engravingexperience') || $(this).data('cyoexperience')) {
				if ($(this).parents('.cart-and-ipay').find('.outOfStock').length) {
					if ($(this).parents('.cart-and-ipay').find('.outOfStock').hasClass('d-none')) {
						$(this).parents('.cart-and-ipay').find('.outOfStock').removeClass('d-none');
					}
					return;
				}
			}

			$('body').trigger('product:beforeAddToCart', this);

			if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
				setPids = [];

				$('.product-detail').each(function () {
					if (!$(this).hasClass('product-set-detail')) {
						setPids.push({
							pid: $(this).find('.product-id').text(),
							qty: $(this).find('.quantity-select').val(),
							options: getOptions($(this))
						});
					}
				});
				pidsObj = JSON.stringify(setPids);
				addAllitemtoCart = true;
				//Product Array setup
				var productSetList = getAllProductSetItemforCart();
				productSetitems.push(productSetList);
			}

			pid = base.getPidValue($(this));

			var $productContainer = $(this).closest('.product-detail');
			if (!$productContainer.length) {
				$productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
			}

			addToCartUrl = getAddToCartUrl();

			var form = {
				pid: pid,
				stlID : stlID ? stlID : '',
				pidsObj: pidsObj,
				childProducts: getChildProducts(),
				quantity: base.getQuantitySelected($(this)),
				pickUp: false
			};

			if ($(this).closest('.product-detail').find('.availability-msg.shipping-msg').length && $(this).closest('.product-detail').find('.availability-msg.shipping-msg').find('li').hasClass('outOfStock') 
			&& $(this).closest('.product-detail').find('.availability-msg.pickup-msg') && $(this).closest('.product-detail').find('.availability-msg.pickup-msg').find('li').hasClass('inStock')) {
				form.pickUp = true;
			}

			if ($(this).data('engravingexperience')) {
				form.pid = $(this).data('pid');
				form.quantity = '1';
				form.pickUp = false;
				form.isEngravable = true;
				isEngraving = true;
			}

			if ($(this).data('cyoexperience')) {
				form.pid = $(this).data('pid');
				form.childProducts = getCyoChildProducts($(this).data('pids'));
				form.quantity = '1';
				form.isCyoExperience = true;
				isCyoExperience = true;
			}

			if ($(this).data('from-cart')) {
				form.fromCart = true;
			}

			if ($(this).data('line-item-uuid')) {
				form.lineItemUUID = $(this).data('line-item-uuid');
			}

			if (!$('.bundle-item').length) {
				form.options = getOptions($productContainer);
			}

			$(this).trigger('updateAddToCartFormData', form);
			if (addToCartUrl) {

				// analytics product listName
				if(fromCYO){
					analyticsAddToCartData = gtmAddToCartData;
				}else{
					if(addAllitemtoCart){
						analyticsAddToCartData = productSetList;
					}else{						
						analyticsAddToCartData.push(gtmKitData);
					}
				}
				form.analyticsAddToCartData = getAnalyticsProductListData(analyticsAddToCartData,fromCYO);
				form.csrf_token = $('input[name=csrf_token]').val();
				var searchParams = new URLSearchParams(window.location.search);
				var cyoAttachFromCart = searchParams.get('CYOAttachFromCart');
				if (cyoAttachFromCart == 'true') {
					if (addToCartUrl.indexOf('?') > -1) {
						addToCartUrl += '&CYOAttachFromCart=true';
					} else {
						addToCartUrl += '?CYOAttachFromCart=true';
					}
				}
				$.spinner().start();
				$.ajax({
					url: addToCartUrl,
					method: 'POST',
					data: form,
					success: function (data) {
						handlePostCartAdd(data,thisEle);
						$('body').trigger('pdp:addToCart',gtmPdpData);
						$('body').trigger('product:afterAddToCart', data);

						if(fromCYO){
							var addtocartdata={};
							addtocartdata.eventLabel = gtmAddToCartData;
							$('body').trigger('cyo:addtocart',addtocartdata);
						}else{
							var gtmArr = {};							
							if(addAllitemtoCart){
								gtmArr.addAllitemtoCart = true;
								gtmArr.productItem = productSetitems;								
							}else{
								gtmArr.addAllitemtoCart = false;
								gtmArr.productItem = gtmKitData;
							}
							$('body').trigger('pdp:productKit', gtmArr);
						}
						
						if ($('#itemAddedFlyout').length) {
							$('#itemAddedFlyout').remove();
						}
						if(!data.error && (isCyoExperience || isEngraving)) {
							$('#cyoAddToCartModal').remove();
							var $cyoAddToCartModalMarkup = $($.trim(data.cyoAddToCartModalMarkup));
							$('body').append($cyoAddToCartModalMarkup);
							$('#cyoAddToCartModal').modal('show');
							if($('.charm-promo-content').length && data.contentAssetBody) {
								$('.charm-promo-content').empty().html(data.contentAssetBody);
							}					
							if($('.woodbox-promo-content').length > 0){
								$('.woodbox-promo-content').html(data.woodboxFlyoutMsg);
							}
						}
						if (!isEngraving && !isCyoExperience) {
							var $itemAddedFlyoutMarkup = $($.trim(data.itemAddedFlyoutMarkup));
							$('body').append($itemAddedFlyoutMarkup);
							
							if($('#itemAddedDialog').find('.recommendations').length > 0 && $('.load-minicart-flyout-recommendation').length > 0 ){
								if($('.load-minicart-flyout-recommendation').find('.recommendations').length > 0){
									$('#itemAddedDialog').find('.recommendations').html($('.load-minicart-flyout-recommendation').find('.recommendations').html());
									$('#itemAddedDialog').find('.recommendations').find('.product-grid').addClass('flyout-carousel');
									carousel.customCarousel('flyout-carousel', MiniCartFlyOutRecommendationCarouselConfig);	
								}
							}
							if($('.charm-promo-content').length && data.contentAssetBody) {
								$('.charm-promo-content').empty().html(data.contentAssetBody);
							}
							if($('.woodbox-promo-content').length > 0){
								$('.woodbox-promo-content').html(data.woodboxFlyoutMsg);
							}
							

							$('#itemAddedFlyout').modal('show');
						}
						$.spinner().stop();
						handlePromoAnalytics(data.cart);
						base.miniCartReportingUrl(data.reportingURL);
					},
					error: function () {
						$.spinner().stop();
					}
				});
			}
		});
	},
	pickAHolder: function () {
		$(document).on('click', 'button.btn-secondary-cyo', function () {
			if ($(this).attr('data-error-message')) {
				if ($('.cyo-error-message').length) {
					var errordata={};

					var $pdpContainer = $(this).parents('.product-detail');
					var shippingStock = $pdpContainer.find('.shipping-delivery-selection .availability-msg');
					var pickupStoreStock = $pdpContainer.find('.shipping-pickup-store .availability-msg');
					var pdpStockMsgShown = shippingStock.find('.inStock').length > 0 || shippingStock.find('.outOfStock').length > 0 || 
						pickupStoreStock.find('.inStock').length > 0 || pickupStoreStock.find('.outOfStock').length > 0 ? true : false;

					if ($pdpContainer.find('.variation-value.selected').length === $pdpContainer.find('.variationOption').length && !pdpStockMsgShown) {
						// If all variation options selected and no stock messages shown, whether OOS/IS this implies 
						// selected variation not available for product.Then show not available message, else continue to appropriate error msg
						$('.selection-error-message').text($(this).attr('data-not-available'));
						errordata.errorMsg =$(this).attr('data-not-available');
					}else {
						let readyToOrder =$pdpContainer.find('.add-to-cart').attr('data-readyto-order');
						if (readyToOrder === false || readyToOrder === 'false') {
							varaitionNotSelectedError($pdpContainer);
						} else {
							$('.selection-error-message').text($(this).attr('data-error-message'));
						}
						errordata.errorMsg =$(this).attr('data-error-message');
					}
				}
				return;
			}
			var url = $(this).attr('data-href');
			var pid = $(this).attr('data-pid');
			var isEngrave = $(this).attr('data-engrave') || false;
			var isPickHolder = $(this).data('pickholder') || false;
			var isAddCharm = $(this).data('charm') || false;
			// var analyticsListName = $.trim($('#navigatedPDPInfo').attr('data-nav-pdpinfo'));  Removed as part of DPC-3208

			if(isEngrave) {
				var windowURL = url + '?pid=' + pid + '&engravingExperience=' + isEngrave + '&navlist=' + 'CYO - Engrave';
				if ($(this).data('product-rating')) {
					windowURL += '&productRating=' + $(this).data('product-rating');
				}
				location.replace(windowURL);
			} else if(isAddCharm) {
				location.replace(`${url}?pid=${pid}&cyoHolderExperience=true&navlist=CYO - Charm Holder`);
			} else if (isPickHolder) {
				location.replace(`${url}?pid=${pid}&cyoCharmExperience=true&navlist=CYO - Charm`);
			}
		});
	},
	changeStore: function () {
		$(document).on('hidden.bs.modal','#storeModalDialog,#storeDeatilsModal', function () {
			var $productContainer = $(this).closest('.set-item');
			if (!$productContainer.length) {
				$productContainer = $(this).closest('.product-detail');
			}
			var url = $productContainer.find('#store-modal').attr('data-updateStoreUrl');
			var productId = $productContainer.find('.product-id').text();
			var quantity = $(this).closest('.product-detail').find('.quantity-input').val();
			if($(this).closest('.bundle-items')) {
				productId = $($productContainer[0]).data('pid');
			}
			var form = {
				pid: productId,
				quantity: quantity,
				csrf_token: $.trim($(this).find('input[name=csrf_token]').val())
			};
			$.spinner().start();
			$.ajax({
				url: url,
				method: 'GET',
				data: form,
				success: function (data) {
					updateAvailability(data, $productContainer);

					if(data.product.productType !== 'master'){
						if (data && data.product &&  data.product.cyoOrEngravingErrorMessage && (data.product.cyoOrEngravingErrorMessage.enableEngraving == false || data.product.cyoOrEngravingErrorMessage.pickHolderOrCharm == false)) {
							if (data.product.readyToOrder) {
								$('.cyo-error-message').addClass('d-none');
							}
							if (data.product.cyoOrEngravingErrorMessage.enableEngraving == false){
								$('button.btn-cyo-engrave', $productContainer).attr('data-error-message', data.product.cyoOrEngravingErrorMessage.errorMessage);
							} 
							if (data.product.cyoOrEngravingErrorMessage.pickHolderOrCharm == false){
								$('button.btn-cyo-pick-holder', $productContainer).attr('data-error-message', data.product.cyoOrEngravingErrorMessage.errorMessage);
								$('button.btn-cyo-addCharm', $productContainer).attr('data-error-message', data.product.cyoOrEngravingErrorMessage.errorMessage);
							}
							if (data.product.cyoOrEngravingErrorMessage.enableEngraving == false && data.product.cyoOrEngravingErrorMessage.pickHolderOrCharm == true){
								$('button.btn-cyo-pick-holder', $productContainer).removeAttr('data-error-message');
								$('button.btn-cyo-addCharm', $productContainer).removeAttr('data-error-message');
							}
							if (data.product.cyoOrEngravingErrorMessage.pickHolderOrCharm == false && data.product.cyoOrEngravingErrorMessage.enableEngraving == true){
								$('button.btn-cyo-engrave', $productContainer).removeAttr('data-error-message');
							}
						} else {
							$('button.btn-secondary-cyo').removeAttr('data-error-message');
							$('.cyo-error-message').addClass('d-none');
						}
					}
					
					$.spinner().stop();
				},
				error: function () {
					$.spinner().stop();
				}
			});
		});
	},
	inventoryTableLoadMore: function () {
		$(document).on('click', '.posInventoryData .inventoryLoadMore', function () {
			var url = $('.inventoryLoadMore').attr('loadmore-url');
			var loadMoreData = $('.posInventoryData').attr('loadmore-data');
			var productID = $('.product-details-id').text();
			$('.inventory-table-overlay').removeClass('d-none');
			$('.tableLoader').addClass('bottom-loader');
			$.ajax({
				url: url,
				method: 'POST',
				data: {
					loadMoreData :loadMoreData,
					productID: productID
				},
				success: function (data) {
					$('.inventoryErrorMsg').addClass('d-none');
					var inventoryData = data.inventoryData;
					var elements = '';
					for (var i in inventoryData) {
						var tableRow = '<tr>';
						for (var key in inventoryData[i]) {
							if (key != 'storeID') {
								tableRow = tableRow + '<td>' + inventoryData[i][key] + '</td>';
							}
						}
						tableRow += '</tr>';
						elements += tableRow;
					}
					$('.inventoryTable table tbody').append(elements);
					$('.posInventoryData').attr('loadmore-data', data.storeIdArr);
					if (!data.storeIdArr.trim()) {
						$('.inventoryLoadMore').addClass('d-none');
					}
					$('.inventory-table-overlay').addClass('d-none');
					$('.tableLoader').removeClass('bottom-loader');
				},
				error: function () {
					$('.posInventoryData').addClass('d-none');
					$('.inventoryErrorMsg').removeClass('d-none');
					$('.inventory-table-overlay').addClass('d-none');
					$('.tableLoader').removeClass('bottom-loader');
				}
			});
		});
	}
});

module.exports = exportBase;

